const SPACES = {
	FORM: 'register_form',
	REFERRAL_INFO: 'referral_info',
};

export default SPACES;
